module.exports = __webpack_public_path__ + "static/Mindfulness-f9337def449c6a82d27ae89b3f9332c4.svg";